import { ojs, app, each, v } from "modular-openscriptjs";
import { gc, uc, pc, dc } from "../declarations";
import { either, sendEvent, store } from "../helpers";
import Navigation from "./Navigation";
import Logo from "./Blocks/Logo";
import Link from "./Blocks/Link";
import SearchIconBtn from "./Blocks/SearchIconBtn";
import ProfilePic from "./ProfilePic";
import BackButton from "./Blocks/BackButton";
import SolidIcon from "./Blocks/SolidIcon";
import BsIcon from "./Blocks/BsIcon";
import SearchBar from "./Blocks/SearchBar";

const h = app("h");
const $e = app("$e");

ojs(
    Logo,
    Link,
    SearchIconBtn,
    ProfilePic,
    BackButton,
    SolidIcon,
    BsIcon,
    SearchBar,
);

export default class TopNav extends Navigation {
    name = "TopNav";

    collapseSideNav() {
        pc.sideNavCollapsed.value = !pc.sideNavCollapsed.value;

        store("sideNavCollapse", pc.sideNavCollapsed?.value ?? false);
    }

    render(items, ...args) {
        return h.header(
            {
                id: "header",
                // Same header for guests and signed-in users - the full
                // navigation is always available (App Store 5.1.1).
                class: "fixed-top d-md-block header-auth-mobile header-primary header-padding-top",
                style: 'z-index: 1021;'
            },
            h.div(
                { class: "px-3" },
                h.div(
                    { class: "row gx-0 gx-lg-3", style: "max-height: 70px;" },
                    h.div(
                        {
                            class: "col-2 col-lg-3 d-grid align-items-center header-left",
                        },
                        h.div(
                            {
                                class: "d-flex align-items-center gap-3",
                            },
                            h.call(() =>
                                h.div(
                                    {
                                        class: "d-flex align-items-center gap-2",
                                    },
                                    h.BackButton({
                                        class: "d-md-none nav-auth-btn",
                                    }),
                                    h.button(
                                        {
                                            class: "btn btn-icon d-none d-md-flex align-items-center justify-content-center",
                                            style: "width: 40px; height: 40px; border-radius: 50%; border: none; background: transparent;",
                                            onclick:
                                                this.method("collapseSideNav"),
                                        },
                                        v(pc.sideNavCollapsed, (c) =>
                                            either(
                                                c.value,
                                                h.BsIcon("chevron-right"),
                                                h.BsIcon("chevron-left"),
                                            ),
                                        ),
                                    ),
                                ),
                            ),
                            h.div(
                                { class: "logo d-none d-md-block" },
                                h.Logo(),
                            ),
                        ),
                    ),

                    h.div(
                        {
                            class: "d-none d-md-grid col-lg-6 col-md-8 align-items-center header-middle",
                        },
                        h.div(
                            { class: "px-md-3" },
                            h.SearchBar(),
                        ),
                    ),

                    h.div(
                        {
                            class: "col-10 d-flex d-md-none align-items-center justify-content-end mobile-search gap-2",
                        },
                        h.div(
                            { class: "flex-fill" },
                            h.SearchBar(),
                        ),
                        // Guests tapping this get the sign-in prompt.
                        h.call(() =>
                            h.button(
                                {
                                    class: `btn btn-outline-secondary border-transparent me-1 nav-auth-btn position-relative d-flex align-items-center justify-content-center p-2`,
                                    onclick: h.func(
                                        "app('router').to",
                                        "user.notifications",
                                    ),
                                    title: "Notifications",
                                },
                                h.i({ class: "bi bi-bell" }),
                                v(dc.notificationsCount, (c) => {
                                    if (c.value?.unread > 0) {
                                        return h.span(
                                            {
                                                class: "position-absolute top-25 start-75 translate-middle badge rounded-pill bg-danger",
                                                style: "font-size: 0.65rem; padding: 0.25em 0.4em;",
                                            },
                                            c.value.unread > 99
                                                ? "99+"
                                                : c.value.unread,
                                            h.span(
                                                { class: "visually-hidden" },
                                                "unread notifications",
                                            ),
                                        );
                                    }
                                    return h.empty();
                                }),
                            ),
                        ),
                    ),

                    h.div(
                        {
                            class: "d-none d-md-grid col-md-2 col-lg-3 align-items-center header-right",
                        },
                        h.div(
                            h.div(
                                {
                                    class: "d-flex align-items-center justify-content-end gap-md-3",
                                },
                                v(gc.auth, (auth) =>
                                    // Notifications, cart and account are shown to
                                    // guests too; guests also get a Sign In button.
                                    h.div(
                                        { class: "d-flex gap-2 align-items-center" },
                                        h.div(
                                            {
                                                class: "d-flex gap-2 align-items-center",
                                            },
                                            h.button(
                                                {
                                                    class: `btn btn-outline-secondary border-transparent me-1 nav-auth-btn position-relative d-flex align-items-center justify-content-center p-2`,
                                                    onclick: h.func(
                                                        "app('router').to",
                                                        "user.notifications",
                                                    ),
                                                    title: "Notifications",
                                                },
                                                h.i({ class: "bi bi-bell" }),
                                                v(
                                                    dc.notificationsCount,
                                                    (c) => {
                                                        if (
                                                            c.value?.unread > 0
                                                        ) {
                                                            return h.span(
                                                                {
                                                                    class: "position-absolute top-25 start-75 translate-middle badge rounded-pill bg-danger",
                                                                    style: "font-size: 0.65rem; padding: 0.25em 0.4em;",
                                                                },
                                                                c.value.unread >
                                                                    99
                                                                    ? "99+"
                                                                    : c.value
                                                                          .unread,
                                                                h.span(
                                                                    {
                                                                        class: "visually-hidden",
                                                                    },
                                                                    "unread notifications",
                                                                ),
                                                            );
                                                        }
                                                        return h.empty();
                                                    },
                                                ),
                                            ),
                                            h.Link(
                                                "a",
                                                h.i({
                                                    class: "bi bi-cart",
                                                }),
                                                "cart",
                                                v(uc.cart, (cart) => {
                                                    return h.span(
                                                        {
                                                            class: "position-absolute bottom-25 start-50  badge rounded-pill bg-danger",
                                                            style: "font-size: 10px;",
                                                        },
                                                        Object.keys(cart.value)
                                                            .length,
                                                    );
                                                }),
                                                {
                                                    role: "button",
                                                    class: `d-none d-md-inline-block btn btn-outline-primary border-transparent position-relative ${
                                                        "nav-auth-btn"
                                                    }`,
                                                },
                                            ),

                                            h.a(
                                                {
                                                    role: "button",
                                                    id: "offcanvas-open-profile-btn",
                                                },
                                                auth.value
                                                    ? {
                                                          data_bs_toggle: "offcanvas",
                                                          data_bs_target:
                                                              "#offcanvasAccount",
                                                          aria_controls:
                                                              "offcanvasAccount",
                                                      }
                                                    : {
                                                          onclick: `sendEvent('${$e.user.needs.authentication}')`,
                                                      },
                                                {
                                                    class: `btn btn-outline-primary border-transparent me-reset ${
                                                        "nav-auth-btn"
                                                    }`,
                                                },
                                                h.i({
                                                    class: "bi bi-person",
                                                }),
                                            ),
                                        ),
                                        either(!auth.value, () =>
                                            h.button(
                                                {
                                                    class: "btn btn-primary rounded-pill fw-bold shadow-sm header-cta-btn d-flex align-items-center gap-2",
                                                    onclick: `sendEvent('${$e.user.needs.authentication}')`,
                                                },
                                                "Sign In",
                                            ),
                                        ),
                                    ),
                                ),
                            ),
                        ),
                    ),
                ),
            ),
            ...args,
        );
    }
}

ojs(TopNav);
